const COLORS = {
    slate: {
        50: '#f8fafc',
        100: '#f1f5f9',
        200: '#e2e8f0',
        300: '#cbd5e1',
        400: '#94a3b8',
        500: '#64748b',
        600: '#475569',
        700: '#334155',
        800: '#1e293b',
        900: '#0f172a',
    },
    blue: {
        50: '#eff6ff',
        100: '#dbeafe',
        200: '#bfdbfe',
        500: '#3b82f6',
        600: '#2563eb',
        700: '#1d4ed8',
    },
    green: {
        50: '#f0fdf4',
        100: '#dcfce7',
        700: '#15803d',
    },
    red: {
        50: '#fef2f2',
        100: '#fee2e2',
        700: '#b91c1c',
    },
};

export default class AppReleaseStyles {
    static shared(theme = {}) {
        return {
            colors: COLORS,
            typeTag: {
                display: 'inline-flex',
                alignItems: 'center',
                padding: '4px 10px',
                borderRadius: 8,
                fontSize: '0.7rem',
                fontWeight: 700,
                textTransform: 'uppercase',
                gap: theme.spacing(0.5),
                letterSpacing: '0.5px',
                verticalAlign: 'middle',
            },
            typeFeature: { backgroundColor: COLORS.green[100], color: COLORS.green[700] },
            typeFix: { backgroundColor: COLORS.red[100], color: COLORS.red[700] },
            typeImprovement: { backgroundColor: COLORS.blue[100], color: COLORS.blue[700] },
            typeOther: { backgroundColor: COLORS.slate[100], color: COLORS.slate[600] },

            content: {
                color: COLORS.slate[700],
                '& .image-container': {
                    width: '100%',
                    height: 140,
                    backgroundColor: COLORS.slate[50],
                    borderRadius: 12,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    fontSize: '3rem',
                    margin: theme.spacing(2, 0),
                    border: `1px solid ${COLORS.slate[100]}`,
                },
                '& h1, & h2, & h3': {
                    color: COLORS.slate[900],
                    fontWeight: 800,
                    marginTop: theme.spacing(3),
                    marginBottom: theme.spacing(1.5),
                },
                '& h1': { fontSize: '1.5rem' },
                '& h2': { fontSize: '1.3rem' },
                '& h3': {
                    fontSize: '1.1rem',
                    color: COLORS.blue[600],
                },
                '& p': {
                    fontSize: '0.95rem',
                    lineHeight: 1.6,
                    marginBottom: theme.spacing(1.5),
                },
                '& strong': {
                    color: COLORS.slate[900],
                    fontWeight: 700,
                },
                '& hr': {
                    border: 'none',
                    borderTop: `1px solid ${COLORS.slate[100]}`,
                    margin: theme.spacing(3, 0),
                },
                '& ul, & ol': {
                    paddingLeft: theme.spacing(2.5),
                    marginBottom: theme.spacing(2),
                    '& li': {
                        marginBottom: theme.spacing(1),
                        fontSize: '0.95rem',
                        lineHeight: 1.5,
                    },
                },
                '& blockquote': {
                    borderLeft: `4px solid ${COLORS.blue[200]}`,
                    paddingLeft: theme.spacing(2),
                    marginLeft: 0,
                    color: COLORS.slate[500],
                    fontStyle: 'italic',
                },
            },

            card: {
                borderRadius: 16,
                boxShadow: '0 4px 20px rgba(0,0,0,0.03)',
                border: `1px solid ${COLORS.slate[100]}`,
                backgroundColor: '#fff',
            },

            closeButton: {
                position: 'absolute',
                right: theme.spacing(1.5),
                top: theme.spacing(1.5),
                color: COLORS.slate[400],
            },

            searchField: {
                width: 300,
                backgroundColor: '#fff',
                borderRadius: 20,
                '& .MuiOutlinedInput-root': {
                    borderRadius: 20,
                    '& fieldset': {
                        borderColor: COLORS.slate[200],
                    },
                    '&:hover fieldset': {
                        borderColor: COLORS.slate[300],
                    },
                    '&.Mui-focused fieldset': {
                        borderColor: COLORS.blue[500],
                    },
                },
            },
        };
    }
}
